module.exports = __webpack_public_path__ + "static/media/account-image-8.0bc0f90f.jpg";